// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"39012661","530":"f91952ac","662":"addd90b6","973":"74824087"}[chunkId] + ".chunk.js";
};